<template>
  <div
    class="grade-graphic"
    :class="{
      passed,
    }"
  >
    <img
      v-if="isPicture"
      class="grade-picture"
      :src="pictureUrl"
      :alt="grade.name"
    />
    <p
      v-else
      class="grade-text"
      :class="{ 'long-string': longString, 'short-string': shortString }"
    >
      {{ grade.name }}
    </p>
  </div>
</template>
<script>
import { getDynCdnImageUrl } from '@/utils/network'

export default {
  name: 'GradeGraphic',
  props: {
    grade: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    passed() {
      return this.grade.passed
    },
    longString() {
      return !this.isPicture && this.grade.name?.length > 7
    },
    shortString() {
      return !this.isPicture && this.grade.name?.length < 4
    },
    isPicture() {
      return !!this.grade.pictureId
    },
    pictureUrl() {
      return getDynCdnImageUrl(this.grade.pictureId)
    },
  },
}
</script>

<style lang="scss" scoped>
.grade-graphic {
  --size: 8em;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  background: $offWhite;
  border-radius: 100%;
  color: $errorText;
  overflow: hidden;

  &.passed {
    color: $successText;
  }
}

.grade-picture {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grade-text {
  margin: -0.2em 0 0;
  padding: 0.7em;
  font-family: $handFont;
  font-size: 2.25em;
  line-height: 1.2em;
  text-align: center;
  transform: rotate(5deg);
  transition: font-size 0.3s;

  &.short-string {
    font-size: 4em;
  }
  &.long-string {
    font-size: 1.5em;
  }
}
</style>
